import { Component, OnInit }          from '@angular/core';
import { ActivatedRoute }             from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { SubscriptionsService }       from './subscriptions.service';
import { Subscription }               from './models/subscription';
import { SubscriptionChannel }        from './models/subscription-channel';
import { SubscriptionPlan }           from './models/subscription-plan';

@Component({
  selector: 'app-subscription-settings',
  templateUrl: './subscription-settings.component.html',
  styleUrls: ['./subscription-settings.component.less']
})
export class SubscriptionSettingsComponent implements OnInit {
  private _subscriptionId: number = null;
  public sub: Subscription = null;
  public subscriptionForm: FormGroup;
  public saving: boolean = false;
  public saved: boolean = false;
  public channels: SubscriptionChannel[] = [];
  public plans: SubscriptionPlan[] = [];
  public error: string;

  constructor(private api: SubscriptionsService, private route: ActivatedRoute, private _fb: FormBuilder) {
    this.route.parent.params.subscribe(params => {
      this._subscriptionId = params['id'];
      this.loadData();
    });
  }

  private loadData() {
    this.api.getSubscription(this._subscriptionId).subscribe(subscription => {
      this.sub = subscription;
      if (this.subscriptionForm) {
        this.setFormValues();
      }
    });
  }

  private setFormValues() {
    let dateValue = null;
    if(this.sub.access_until) {
      dateValue = this.sub.access_until.substr(0, 10);
    }
    this.subscriptionForm.controls['name'].setValue(this.sub.name);
    this.subscriptionForm.controls['invitation_token'].setValue(this.sub.invitation_token);
    this.subscriptionForm.controls['active'].setValue(this.sub.active);
    this.subscriptionForm.controls['access_until'].setValue(dateValue);
    this.subscriptionForm.controls['seats'].setValue(this.sub.seats);
    this.subscriptionForm.controls['channel_id'].setValue(this.sub.channel ? this.sub.channel.id : null);
    this.subscriptionForm.controls['plan_id'].setValue(this.sub.plan.id);
    this.subscriptionForm.controls['discount_token'].setValue(this.sub.discount_token);
    this.subscriptionForm.controls['interval'].setValue(this.sub.interval);
    if (this.sub.billing) {
      this.subscriptionForm.controls['address'].setValue(this.sub.billing.address);
      this.subscriptionForm.controls['next_payment_due'].setValue(
        this.sub.billing.next_payment_due
        ? this.sub.billing.next_payment_due.substr(0, 10)
        : null);
      this.subscriptionForm.controls['auto_renew'].setValue(this.sub.billing.auto_renew);
    }
  }

  ngOnInit() {
    this.api.getChannels().subscribe(channels => this.channels = channels);
    this.api.getPlans().subscribe(plans => this.plans = plans);

    this.subscriptionForm = this._fb.group({
      id: [''],
      access_until: [''],
      seats: [''],
      address: [''],
      invitation_token: [''],
      channel_id: [''],
      plan_id: [null],
      name: [null],
      active: [false],
      discount_token: [null],
      interval: [''],
      next_payment_due: [null],
      auto_renew: [false],
    });
    if (this.sub) {
      this.setFormValues();
    }
  }

  save(settings) {
    this.error = null;
    this.saving = true;
    this.saved = false;
    this.api.updateSubscription(this._subscriptionId, settings).subscribe(() => {
      this.saving = false;
      this.saved = true;
      this.subscriptionForm.markAsPristine();
    }, error => {
      this.saving = false;
      try {
        this.error = error.json().error.description;
      }
      catch(e) {
        console.error(error);
        this.error = 'An unknown error occurred';
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/subscriptions/subscription-settings.component.ts